import { apiClient } from './client'

// ─── Types ────────────────────────────────────────────────────────────────────

export interface CodeStructureSegment {
  ai: string
  required: boolean
  length?: number
  min_length?: number
  max_length?: number
  luhn?: boolean
}

export interface CodeStructure {
  segments: CodeStructureSegment[]
  forbid_cyrillic: boolean
  custom_regex?: string | null
  notes?: string
}

export interface ProductGroupStructureItem {
  code: string
  name: string
  enabled: boolean
  configured: boolean
  structure: CodeStructure | null
}

export interface ValidatePreviewResponse {
  ok: boolean
  reason: string
  parsed: Record<string, string>
}

/** Минимальная сводка для воркер-скан pre-валидатора (без admin-доступа). */
export interface PublicStructureSummary {
  code: string
  configured: boolean
  forbid_cyrillic: boolean
  min_total_length: number | null
  max_total_length: number | null
}

// ─── API ──────────────────────────────────────────────────────────────────────

export const codeStructuresApi = {
  list: () =>
    apiClient.get<{ items: ProductGroupStructureItem[] }>(
      '/api/product-groups/structures',
    ),
  get: (code: string) =>
    apiClient.get<ProductGroupStructureItem>(
      `/api/product-groups/${encodeURIComponent(code)}/structure`,
    ),
  getPublic: (code: string) =>
    apiClient.get<PublicStructureSummary>(
      `/api/product-groups/${encodeURIComponent(code)}/structure/public`,
    ),
  save: (code: string, structure: CodeStructure) =>
    apiClient.put<ProductGroupStructureItem>(
      `/api/product-groups/${encodeURIComponent(code)}/structure`,
      { structure },
    ),
  clear: (code: string) =>
    apiClient.delete<{ code: string; configured: false }>(
      `/api/product-groups/${encodeURIComponent(code)}/structure`,
    ),
  validate: (code: string, testCode: string, structure?: CodeStructure) =>
    apiClient.post<ValidatePreviewResponse>(
      `/api/product-groups/${encodeURIComponent(code)}/structure/validate`,
      structure ? { code: testCode, structure } : { code: testCode },
    ),
}
